import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-550a6f9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "wrapper"
}

import { onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';

import { getBanners, BannerProps } from '@/api/landing';
import { OvertaxStorage } from '@/utils/overtax'
import { setUtmForTracking } from '@/utils/utmHandler'

import LandingHeader from './components/LandingHeader.vue'
import LandingMain from './components/LandingMain.vue'
import LandingFeedback from './components/LandingFeedback.vue'
import LandingNews from './components/LandingNews.vue'
import LandingExpert from './components/LandingExpert.vue'
import LandingWhy from './components/LandingWhy.vue'
import LandingRecommend from './components/LandingRecommend.vue'
import LandingProcess from './components/LandingProcess.vue'
import LandingOvertax from './components/LandingOvertax.vue'
import LandingVideo from './components/LandingVideo.vue'
import LandingFQA from './components/LandingFQA.vue'
import LandingBanner from './components/LandingBanner.vue'
import LandingNotice from './components/LandingNotice.vue'
import LandingFooter from './components/LandingFooter.vue'
import RefundToast from './components/RefundToast.vue'

import MedistreamMain from './componentsForMedistream/Main.vue'
import BannerTemplate from './components/BannerTemplate.vue'
import BannerForTimer from './components/BannerForTimer.vue'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingView',
  setup(__props) {

const route = useRoute()
const landingTarget = ref('')
const banners = ref<BannerProps[]>([])
const showTimer = ref(true)
const showNotice = ref(false)

onBeforeMount(() => {
  const { target, code, utm_source } = route.query
  if (code) {
    OvertaxStorage.set('sales_id', code)
  } else {
    OvertaxStorage.init('sales_id')
  }

  setUtmForTracking()

  if (target === 'medistream') {
    landingTarget.value = target
  }

  if (utm_source === 'knbnk') {
    showNotice.value = true
  }

  getBanners().then((res) => {
    banners.value = res
  }).catch(() => {
    banners.value = []
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!landingTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["landing-wrapper", {
      timer: showTimer.value,
    }])
        }, [
          _createVNode(LandingHeader),
          _createVNode(LandingMain),
          _createVNode(LandingFeedback),
          _createVNode(LandingVideo),
          false
            ? (_openBlock(), _createBlock(LandingNews, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(LandingExpert),
          _createVNode(LandingWhy),
          _createVNode(LandingRecommend),
          _createVNode(LandingProcess),
          _createVNode(LandingOvertax),
          _createVNode(LandingFQA),
          _createVNode(LandingBanner),
          (showNotice.value)
            ? (_openBlock(), _createBlock(LandingNotice, { key: 1 }))
            : _createCommentVNode("", true),
          _createVNode(LandingFooter),
          _createVNode(RefundToast)
        ], 2))
      : _createCommentVNode("", true),
    (landingTarget.value === 'medistream')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(MedistreamMain)
        ]))
      : _createCommentVNode("", true),
    (showTimer.value)
      ? (_openBlock(), _createBlock(BannerForTimer, {
          key: 2,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showTimer.value = false))
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banners.value, (banner, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createVNode(BannerTemplate, { banner: banner }, null, 8, ["banner"])
      ]))
    }), 128))
  ], 64))
}
}

})